__turbopack_context__.v({
  "localeSwitcher": "RJxt0q_localeSwitcher",
});
